import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HealthStats } from '../models/healthstats.model';
import { Namespace } from '../models/namespace.model';

const baseUrl = `${environment.apis.cds}/HealthStats`;

@Injectable({
  providedIn: 'root',
})

export class HealthStatsService {
  constructor(
    private http: HttpClient) { }

  getServicesHealthStats(): Observable<HealthStats[]> {
    return this.http.get<HealthStats[]>(`${baseUrl}/GetServicesHealthStats`);
  }

  getHealthStatsLastRefresh(): Observable<string> {
    return this.http.get<string>(`${baseUrl}/GetHealthStatsLastRefresh`);
  }

  getNamespaces(refresh: boolean = false): Observable<Namespace[]> {
    return this.http.get<Namespace[]>(`${baseUrl}/Namespaces?refresh=${refresh}`);
  }
  
}
